import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  
  @Input() sideBar = true

  protected currentYear: number = new Date().getFullYear();

  constructor() { }

  ngOnInit() {
  }
}
